<template>
  <div>
    <div v-if="form && form.corpo">
      
        <h2 class="form-title pb-4 pl-0 ml-0">{{ form.titulo }} </h2>

        <div :class="`${ form.col || 'col-xs-12'}`">

          <div class="row align-start" v-for="(linha, i) in agrupadoPorLinha" :key="i">
            <template v-for="(listaDeCampos, index) in linha">

              <div
                v-if="
                  listaDeCampos.type == 'textarea' &&
                  listaDeCampos.mascara == null &&
                  verificadorCondicional(listaDeCampos.show) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :key="`ta_${listaDeCampos.name}`"
                :class="`${listaDeCampos.col}`"
              >
                <v-textarea
                  :name="listaDeCampos.name"
                  :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                  v-model="values[listaDeCampos.name]"
                  rows="3"
                  dense
                  outlined
                  :readonly="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                  :disabled="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                />
              </div>
              <div
                v-else-if="
                  listaDeCampos.type != 'hidden' &&
                  listaDeCampos.mascara == null &&
                  verificadorCondicional(listaDeCampos.show) &&
                  handleRegrasDadosExternos(listaDeCampos) &&
                  (listaDeCampos.type == 'text' ||
                  listaDeCampos.type == 'url' ||
                  listaDeCampos.type == 'number')
                "
                :key="`tf_${listaDeCampos.name}`"
                :class="`${listaDeCampos.col}`"
              >
                <v-text-field
                  :name="listaDeCampos.name"
                  :type="listaDeCampos.type"
                  :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                  v-model="values[listaDeCampos.name]"
                  dense
                  outlined
                  :readonly="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                  :disabled="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                />
              </div>
              <div
                v-else-if="
                  listaDeCampos.type != 'hidden' &&
                  listaDeCampos.mascara != null &&
                  verificadorCondicional(listaDeCampos.show) &&
                  handleRegrasDadosExternos(listaDeCampos) &&
                  (listaDeCampos.type == 'text' ||
                  listaDeCampos.type == 'url' ||
                  listaDeCampos.type == 'number')
                "
                :key="`tfm_${listaDeCampos.name}`"
                :class="`${listaDeCampos.col}`"
              >
                <v-text-field
                  :name="listaDeCampos.name"
                  :type="listaDeCampos.type"
                  :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                  v-model="values[listaDeCampos.name]"
                  dense
                  outlined
                  v-mask="`${ listaDeCampos.mascara }`"
                  :readonly="listaDeCampos.readonly || false"
                />
              </div>
              <input v-else-if="
                  listaDeCampos.type == 'hidden' &&
                  listaDeCampos.type != 'text' &&
                  listaDeCampos.type != 'select' &&
                  listaDeCampos.type != 'textarea' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :type="listaDeCampos.type"
                :name="listaDeCampos.name  + '_' + index"
                :key="listaDeCampos.name+'_keyhiddentxtipt_'+idx"
                :value="values[listaDeCampos.name] = listaDeCampos.value"
              />

              <!-- <TexInputComponent
                v-else-if="
                  listaDeCampos.type == 'hidden' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name+'_field_'+idx"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="listaDeCampos.col"
                :key="listaDeCampos.name"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.name"
              /> -->
              <ComboboxInputComponent
                v-else-if="
                  listaDeCampos.type == 'select' &&
                  verificadorCondicional(listaDeCampos.show) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} input-padrao-formulate`"
                :key="`${listaDeCampos.name}_id`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              ></ComboboxInputComponent>

              <ComboboxInputComponent
                v-else-if="
                  listaDeCampos.type == 'select-agrupado' &&
                  verificadorCondicional(listaDeCampos.show) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="filtrarOpcoesPorGrupo(listaDeCampos)"
                :class="`${listaDeCampos.col} input-padrao-formulate`"
                :key="`${listaDeCampos.name}_agrupado_${values[listaDeCampos.name]}`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              ></ComboboxInputComponent>

              <ComboboxInputComponent
              v-else-if="
                listaDeCampos.type == 'select-avancado' &&
                verificadorCondicional(listaDeCampos.show)
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :options="listaDeCampos.options[retornaValorEnderecamento(listaDeCampos.nome_enderecamento)]"
              :class="[listaDeCampos.col]"
              :key="`sel_avancado_${listaDeCampos.name}`"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
            ></ComboboxInputComponent>

              <AutocompleteComponent
                v-else-if="
                  listaDeCampos.type == 'autocomplete' &&
                  verificadorCondicional(listaDeCampos.show) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} input-padrao-formulate`"
                :key="`autocomplete_${listaDeCampos.name}_${index}_${listaDeCampos.options.length}`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation="listaDeCampos.validation"
                :validation-name="listaDeCampos.name"
                :loading="listaDeCampos.options == 0"
                
              ></AutocompleteComponent>

              <RadioInputComponent
                v-else-if="listaDeCampos.type == 'radio' &&
                  handleRegrasDadosExternos(listaDeCampos)"
                :name="listaDeCampos.name"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="listaDeCampos.col"
                :validation="listaDeCampos.validation"
                :key="'radio_'+listaDeCampos.name"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              >
              </RadioInputComponent>

              <DateInputComponent
                v-else-if="
                  (listaDeCampos.type == 'date' ||
                  listaDeCampos.type == 'time' ||
                  listaDeCampos.type == 'date-time' ||
                  listaDeCampos.type == 'datetime-local') &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type == 'date-time' ? 'datetime-local' : listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="listaDeCampos.col"
                :key="`date_${listaDeCampos.name}`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              />  
              
              <SGPFormAutocompleteComponent
                v-else-if="
                  listaDeCampos.type == 'requisicao' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :listaDeOptions="listaDeCampos.options"
                optionLabel="label"
                optionValue="value"
                :class="`${listaDeCampos.col} input-requisicao`"
                :key="`req_${listaDeCampos.name}`"
                v-model="values[listaDeCampos.name]"
                mostrarSelecione
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              />

            </template>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
import RadioInputComponent from './RenderizacaoFormularioDinamicoComponent/components/RadioInputComponent.vue';
import ComboboxInputComponent from './RenderizacaoFormularioDinamicoComponent/components/ComboboxInputComponent.vue';
import DateInputComponent from './RenderizacaoFormularioDinamicoComponent/components/DateInputComponent.vue';
import AutocompleteComponent from './RenderizacaoFormularioDinamicoComponent/components/AutocompleteComponent.vue';
import moment from 'moment';

import HttpClient from '@/common/boot/HttpClient'
import { processarCampoComputado, criarMapaDependencias } from '../service/CamposComputadosService'
// import criarToast from '@/common/boot/ToastsHandler'

export default {
  name: "RenderizaFormularioComponent",

  components: {
    RadioInputComponent,
    ComboboxInputComponent,
    DateInputComponent,
    AutocompleteComponent
  },

  props: {
    json: {
      type: [Object, Array],
      required: false,
      default: null
    },

    dadosExternos: {
      type: [Boolean, Object],
      required: false,
      default: false
    }
  },

  data () {
    return {
      values: {},
      validation: [],
      mapaDependencias: {}
    }
  },

  async created () {
    await this.setarVariaveisDoFormulario()
    this.criarMapaDependenciasCampos()
    this.processarCamposComputados()
    this.requestDadosDoCampo()
  },

  computed: {
    form () {
      return this.$props.json
    },

    agrupadoPorLinha() {
      if (!this.form || !this.form.corpo) {
        return {};
      }
      const resultado = {};
      this.form.corpo.forEach(obj => {
        if (!resultado[obj.linha]) {
          resultado[obj.linha] = []
        }
        resultado[obj.linha].push(obj);
      })
      return resultado;
    }
  },

  methods: {
    filtrarOpcoesPorGrupo (campo) {
      const opcoes = (campo.ctrl_campos_opcoes || []).map(o => ({ label: o.label, value: o.val, grupo: o.grupo }))

      if (!campo.show || typeof campo.show !== 'string') {
        return opcoes
      }

      const match = campo.show.match(/(?:this\.values\.|values\.)(\w+)\s*[=!<>]/)
      if (!match) return opcoes

      const campoGatilho = match[1]
      const valorAtual = this.values[campoGatilho]

      if (!valorAtual) return opcoes

      return opcoes.filter(o => o.grupo === valorAtual)
    },

    normalizarExpressao (expr) {
      // Quando múltiplas regras do mesmo campo são unidas com &&
      // (ex: campo == 'a' && campo == 'b'), o resultado é sempre false.
      // Converte para || quando todas as partes referenciam o mesmo campo.
      const partesAnd = expr.split(' && ')
      if (partesAnd.length <= 1) return expr

      const campos = partesAnd.map(parte => {
        const match = parte.match(/(?:this\.values\.|values\.)([\w]+)\s*[=!<>]/)
        return match ? match[1] : null
      })

      if (campos.every(c => c !== null && c === campos[0])) {
        return partesAnd.join(' || ')
      }

      return expr
    },

    verificadorCondicional (val) {
      if (typeof val === 'boolean') {
        return val
      }
      
      if (typeof val === 'string') {
        try {
          const exprNormalizada = this.normalizarExpressao(val)
          const func = new Function('values', `with(this) { return ${exprNormalizada.replace(/this\.values/g, 'values')} }`)
          return func.call(this, this.values)
        } catch (error) {
          console.error('Erro ao avaliar condicional:', val, error)
          return true
        }
      }
      
      return true
    },

    requestDadosDoCampo() {
      if (!this.json || !this.json.corpo) {
        return;
      }
      let listaDeDados = []

      this.json.corpo.forEach(campo => {
        if (campo.ctrl_campo_endpoint) {
            HttpClient({ method: campo.ctrl_campo_endpoint.metodo, url: campo.ctrl_campo_endpoint.endpoint}).then(response => {
            listaDeDados = response.data.data.map(dados => {
              return {
                label: dados[campo.ctrl_campo_endpoint.option_label],
                value: dados[campo.ctrl_campo_endpoint.option_value]
              }
            })

            campo.options = listaDeDados
          })
        }
      })

      return listaDeDados
    },

    inputEhObrigatorio(validation) {
      if (!validation) return ''
      if (validation.includes('nullable')) return ''
      return '*'
    },

    setarVariaveisDoFormulario () {
      if (!this.json || !this.json.corpo || this.json.corpo.length == 0) {
        return false;
      }

      let dateTypes = ['date', 'date-time']
      let optionsTypes = ['select', 'select-agrupado', 'radio'];

      this.json.corpo.forEach((item) => {
        if (dateTypes.includes(item.type) && item.type == 'date') {          
          this.$set(this.values, item.name, item.data_corrente ? moment(Date.now()).format("YYYY-MM-DD") : '')
          return
        }

        if (dateTypes.includes(item.type) && item.type == 'date-time') {          
          this.$set(this.values, item.name, item.data_corrente ? moment(Date.now()).format("YYYY-MM-DD HH:mm:ss") : '')
          return
        }

        if (optionsTypes.includes(item.type)) {
          this.$set(this.values, item.name, item.value ? item.value : '')
          return
        }

        if (item.mascara && item.mascara.includes('#')) {
          const valorNumerico = (item.value || '').replace(/\D/g, '');
          this.$set(this.values, item.name, valorNumerico)
          return
        }

        this.$set(this.values, item.name, item.value || '')
      })

      return true;
    },

    inputCallback (val) {
      if (val && typeof val === 'object' && 'name' in val && 'model' in val) {
        this.$set(this.values, val.name, val.model)
      }
      if (!val || !val.name) {
        return
      }
      
      this.$set(this.values, val.name, val.model)
      this.atualizarCamposComputadosDependentes(val.name)
    },

    retornaValorEnderecamento(enderecamento) {
      /* O endereçamento representa e o vinculo com os campos que possibilita a captura do valor deles */
      if(Array.isArray(enderecamento)) {
        const valorEnderecamentos = enderecamento.map(nome => this.values[nome]).join('__');        
        return valorEnderecamentos
      }

      if (enderecamento) {
        return this.values[enderecamento]
      } else {
        return ["Não existe valor disponível"]
      }
    },

    handleRegrasDadosExternos (campo) {
      let retorno = true

      if (!this.dadosExternos) {
        return retorno
      }

      if (typeof this.dadosExternos === 'object') {       
        if (campo && campo.expressoes_logicas_externas && campo.expressoes_logicas_externas.length) {

          let parsedRegras = campo.expressoes_logicas_externas.map(regra => {
            const valorPath = this.recuperarValorPeloPath(this.dadosExternos, regra.path)

            const comando =  regra.ctrl_expressao_booleana.comando

            if (regra.option_value) {
              // let optionsFinal = {}
              for (const key in campo.options) {
                if(campo.options[key] == regra.option_value) {
                  if (this.verificadorCondicional(`"${valorPath}" ${comando} "${regra.value}"`)) {
                    // optionsFinal.push({[key]: campo.options[key]})
                    campo.options = regra.options
                  }
                }
              }

              // campo.options = Object.assign({}, ...optionsFinal)

              // campo.options = optionsFinal
              //  = [...campo.options.filter(option => {
              //   console.log('Option tem regra: ', option, regra, `"${valorPath}" ${comando} "${regra.value}"`)

              //   return true
              // })]
            }

            return `${regra.operador_logico ? regra.operador_logico : ''} "${valorPath}" ${comando} "${regra.value}"`

            // if (regra.options && regra.options.length && valorPath == regra.value) {
            //   campo.options = campo.options.filter(campoOption =>
            //     !regra.options.some(regraOption => regraOption.val === campoOption.value)
            //   )
            // } else {
            //   retorno = valorPath == regra.value
            // }

          })

          parsedRegras = parsedRegras.join(' ');

          retorno = this.verificadorCondicional(parsedRegras)
        }
      }
      return retorno
    },

    recuperarValorPeloPath(obj, path) {
      return path.split('.').reduce((acc, key) => acc && acc[key], obj);
    },

    verificadorDeValidacao(event) {
      const hasInput = this.validation.find(input => input.name === event.name) || false;
      if(!hasInput) {    
        this.validation.push(event)
      } else {
        this.validation = this.validation.map(input => {
          if(input.name === event.name) {
            input = event
          }
          return input 
        })
      }      
    },

    criarMapaDependenciasCampos() {
      if (!this.json || !this.json.corpo) {
        return;
      }
      this.mapaDependencias = criarMapaDependencias(this.json.corpo);
    },

    processarCamposComputados() {
      if (!this.json || !this.json.corpo) {
        return;
      }
      
      this.json.corpo.forEach(campo => {
        if (campo.computed && campo.computed.format) {
          const valorComputado = processarCampoComputado(campo, this.values);
          this.$set(this.values, campo.name, valorComputado);
        }
      });
    },

    atualizarCamposComputadosDependentes(nomeCampo) {
      const camposDependentes = this.mapaDependencias[nomeCampo] || [];
      
      camposDependentes.forEach(nomeCampoDependente => {
        const campoDependente = this.json.corpo.find(c => c.name === nomeCampoDependente);

        if (campoDependente && campoDependente.computed) {
          const valorComputado = processarCampoComputado(campoDependente, this.values);
          console.log('🔶 [MODAL PREVIEW] Novo valor computado:', valorComputado)
          
          // Replace entire object to trigger Vue reactivity
          this.values = {
            ...this.values,
            [campoDependente.name]: valorComputado
          };
        }
      });
    }
  },

  watch: {
    values: {
      handler(newValue, oldValue) {
        for (const key in newValue) {
          if (oldValue && oldValue[key] !== newValue[key]) {
            this.atualizarCamposComputadosDependentes(key);
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.row.align-start {
  align-items: flex-start !important;
  
  > div {
    padding-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

.campo-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  margin-top: 0;
  line-height: 1.5;
  min-height: 21px;
}

.input-padrao-formulate {
  border: solid 0px #ccc;
  margin-top: 0;
  margin-bottom: 0 !important;
  padding-top: 0 !important;

  label {
    font-size: 12px !important;
    margin-top: 0 !important;
  }

  .v-input {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    
    fieldset {
      height: 36px !important;
    }
  }

  .v-textarea {
    fieldset {
      height: auto !important;
    }
  }
}

// Normalizar todos os tipos de campo
.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
  margin-bottom: 0 !important;
  
  > * {
    margin-bottom: 0 !important;
  }
}

.input-requisicao {
  padding-top: 0 !important;
  
  label {
    position: relative;
    display: block;
    font-size: 12px !important;
    margin-top: 0 !important;
    margin-bottom: 2px !important;
  }

  .v-input {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  .v-text-field--enclosed {
    fieldset {
      height: 36px !important;
    }
  }

  .v-input--is-label-active {
    fieldset {
      height: auto !important;
    }
  }
}
</style>